import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AiIntegrationAuthInterceptor } from './interceptor/ai-integration-auth.interceptor';
import { EnvironmentType } from './classes/iqBoost';
import { AiFeaturesService } from './services/ai-features.service';
import { ExchangeConsentService } from './services/exchange-consent.service';
import { LangGraphService } from './services/langgraph.service';
import { MaximizerAiService } from './services/maximizer-ai.service';
import { PiiAnonymizationService } from './services/pii-anonymization.service';
import { AIStore } from './state/ai.store';
import { IQBoostAllHouseholdsStore } from './state/iqboost-all-households.store';
import { IQBoostSingleHouseholdStore } from './state/iqboost-single-household.store';
import { IQBoostViewStore } from './state/iqboost-view.store';
import {
  DEFAULT_LANGGRAPH_CONFIG,
  INTEGRATION_IQ_BOOST_URL,
  INTEGRATION_SUBSCRIPTION_KEY,
  INTEGRATION_WEB_APP_URL,
  LANGGRAPH_CONFIG,
  LangGraphConfig,
} from './types/injection-token';
import { UdoService } from '@maximizer/core/shared/data-access';

/** Prompts resolve via the IQ Boost API. */
export interface AiDataAccessConfig {
  /** Unused; optional so Outlook's existing call still compiles. */
  environment?: EnvironmentType;
  integrationWebAppUrl: string;
  integrationIqBoostUrl: string;
  integrationSubscriptionKey: string;
  /** LangGraph orchestrator settings. Apps without the orchestrator omit it. */
  langGraph?: LangGraphConfig;
}

export function provideAiDataAccess(
  config?: AiDataAccessConfig,
): EnvironmentProviders {
  const configurationProviders = config
    ? [
        {
          provide: INTEGRATION_IQ_BOOST_URL,
          useValue: config.integrationIqBoostUrl,
        },
        {
          provide: INTEGRATION_WEB_APP_URL,
          useValue: config.integrationWebAppUrl,
        },
        {
          provide: INTEGRATION_SUBSCRIPTION_KEY,
          useValue: config.integrationSubscriptionKey,
        },
        {
          provide: LANGGRAPH_CONFIG,
          useValue: config.langGraph ?? DEFAULT_LANGGRAPH_CONFIG,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AiIntegrationAuthInterceptor,
          multi: true,
        },
      ]
    : [];

  return makeEnvironmentProviders([
    AiFeaturesService,
    IQBoostViewStore,
    IQBoostAllHouseholdsStore,
    IQBoostSingleHouseholdStore,
    AIStore,
    MaximizerAiService,
    PiiAnonymizationService,
    UdoService,
    ExchangeConsentService,
    LangGraphService,
    ...configurationProviders,
  ]);
}
